/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SupressProgramBudgetTypeTipMessageInput = {|
  key?: ?string,
  personId?: ?string,
  value?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type SupressProgramBudgetTypeTipMessageMutationVariables = {|
  input: SupressProgramBudgetTypeTipMessageInput
|};
export type SupressProgramBudgetTypeTipMessageMutationResponse = {|
  +supressProgramBudgetTypeTipMessage: ?{|
    +clientMutationId: ?string,
    +person: ?{|
      +id: string,
      +supressProgramBudgetTypeTipMessage: ?$ReadOnlyArray<?string>,
    |},
  |}
|};
export type SupressProgramBudgetTypeTipMessageMutation = {|
  variables: SupressProgramBudgetTypeTipMessageMutationVariables,
  response: SupressProgramBudgetTypeTipMessageMutationResponse,
|};
*/


/*
mutation SupressProgramBudgetTypeTipMessageMutation(
  $input: SupressProgramBudgetTypeTipMessageInput!
) {
  supressProgramBudgetTypeTipMessage(input: $input) {
    clientMutationId
    person {
      id
      supressProgramBudgetTypeTipMessage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SupressProgramBudgetTypeTipMessageInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SupressProgramBudgetTypeTipMessagePayload",
    "kind": "LinkedField",
    "name": "supressProgramBudgetTypeTipMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Person",
        "kind": "LinkedField",
        "name": "person",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "supressProgramBudgetTypeTipMessage",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SupressProgramBudgetTypeTipMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SupressProgramBudgetTypeTipMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "SupressProgramBudgetTypeTipMessageMutation",
    "operationKind": "mutation",
    "text": "mutation SupressProgramBudgetTypeTipMessageMutation(\n  $input: SupressProgramBudgetTypeTipMessageInput!\n) {\n  supressProgramBudgetTypeTipMessage(input: $input) {\n    clientMutationId\n    person {\n      id\n      supressProgramBudgetTypeTipMessage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '41e6d863af861b2e1d5b1b22b1826a7f';

module.exports = node;
